import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SwapStatusEnumKeys } from '@libs/types';
import { RejectedIcon, SuccesIcon } from '../../assets';
import { Container, SuccesText, FailedText } from './styles';
export const SwapStatus = ({ status, rejectionText, finishedText, className, shouldNotShowText, }) => {
    const failedStatusesArray = [
        SwapStatusEnumKeys.DEPOSIT_FAILED,
        SwapStatusEnumKeys.EXCHANGE_FAILED,
        SwapStatusEnumKeys.WITHDRAW_FAILED,
    ];
    const hasFinished = status === SwapStatusEnumKeys.WITHDRAW_COMPLETED;
    const hasFailed = !!status && failedStatusesArray.includes(status);
    if (!hasFailed && !hasFinished)
        return null;
    return (_jsxs(Container, { className: className, children: [hasFinished && (_jsxs(_Fragment, { children: [_jsx(SuccesIcon, {}), !shouldNotShowText && (_jsx(SuccesText, { fontFamily: "primaryBold", children: finishedText }))] })), hasFailed && (_jsxs(_Fragment, { children: [_jsx(RejectedIcon, {}), !shouldNotShowText && (_jsx(FailedText, { fontFamily: "primaryBold", children: rejectionText }))] }))] }));
};
export default SwapStatus;
//# sourceMappingURL=SwapStatus.js.map